import React from 'react';
import { Grid } from '@mui/material';
import { useRecoilState } from 'recoil';
import Form from 'pages/myidm/components/Form';
import FormCard from 'pages/myidm/components/form-card';
import { OrderPayload } from 'pages/myidm/store';
import { AD_GROUP, LDAP_GROUP, REQUEST_TYPE, MODIFY_REQUEST_TYPE } from 'pages/myidm/utils/constant';
import MembersListModal from 'pages/myidm/MembersListModal';
import MemberslList from 'pages/myidm/components/sections/MemberslList';
import MultipleMemberslList from 'pages/myidm/components/sections/multiple/MultipleMemberslList';
import ResourceSectionForNewAdGroupMembership from './ad-group-new-membership/ResourceSection';
import ResourceSectionForDisable from './ad-group-disable/ResourceSection';
import ResourceSectionForModifyAdGroupMembership from './ad-group-modify-membership/ResourceSection';
import ResourceSectionForAdGroupOwnerChange from './ad-group-group-owner-change/ResourceSection';
import ADGroupForRemoval from './ad-group-membership-removal/ADGroup';
import NewAdGroupMembersList from './ad-group-new-membership/MemberslList';

const MemberForm = () => {
    const [order, setOrder] = useRecoilState(OrderPayload);
    const isNewRequest = order?.typeOfRequest === REQUEST_TYPE.NEW;
    const isModifyRequest = order?.typeOfRequest === REQUEST_TYPE.MODIFY;
    const isDisableGroupRequest = order?.typeOfRequest === REQUEST_TYPE.DISABLE_GROUP;
    const isLdapGroupType = order?.groupType === LDAP_GROUP;
    const isAdGroupType = order?.groupType === AD_GROUP;

    // New logic based on modifyRequestType
    const isMembershipModify = order?.modifyRequestType === MODIFY_REQUEST_TYPE.MEMBERSHIP;
    const isRemovalModify = order?.modifyRequestType === MODIFY_REQUEST_TYPE.REMOVAL;
    const isGroupOwnerChangeModify = order?.modifyRequestType === MODIFY_REQUEST_TYPE.GROUP_OWNER_CHANGE;

    const isNewLdapGroup = isNewRequest && isLdapGroupType;
    const isNewAdGroup = isNewRequest && isAdGroupType;

    // Updated modify logic to use modifyRequestType
    const isModifyLdapGroup = isModifyRequest && isLdapGroupType && isMembershipModify;
    const isModifyAdGroup = isModifyRequest && isAdGroupType && isMembershipModify;
    const isModifyAdGroupMembershipRemoval = isModifyRequest && isAdGroupType && isRemovalModify;
    const isModifyAdGroupOwnerChange = isModifyRequest && (isLdapGroupType || isAdGroupType) && isGroupOwnerChangeModify;

    // Reset AD Group array if certain values change
    React.useEffect(() => {
        if (isNewRequest || !isAdGroupType) {
            setOrder({
                ...order,
                multipleAdGroups: [{ adGroup: null, adGroupOwner: null, domainType: null, members: [] }],
            });
        }
    }, [order?.typeOfRequest, order?.groupType]);
    return (
        <>
            <Grid item xs={12}>
                <FormCard title="Request Type " gap={0} margin={2}>
                    <Grid item container spacing={2} sx={{ mt: 1, mb: 1 }}>
                        <Grid item md={6} sm={6} xs={12}>
                            <Form.TypeOfRequest />
                        </Grid>
                        {(isNewRequest || isModifyRequest) && (
                            <Grid item md={6} sm={6} xs={12}>
                                <Form.GroupType />
                            </Grid>
                        )}
                        {isModifyRequest && order?.groupType && (
                            <Grid item md={6} sm={6} xs={12}>
                                <Form.ModifyRequestType />
                            </Grid>
                        )}
                        {(isModifyAdGroup || isModifyAdGroupMembershipRemoval) && (
                            <Grid item md={6} sm={6} xs={12}>
                                <Form.DomainType />
                            </Grid>
                        )}
                    </Grid>
                </FormCard>
            </Grid>
            <Grid item xs={12}>
                <FormCard title="Application " gap={0} margin={2}>
                    <Grid item container spacing={2} sx={{ mt: 1, mb: 1 }}>
                        <Grid item md={6} sm={6} xs={12}>
                            <Form.Sector />
                        </Grid>
                        <Grid item md={6} sm={6} xs={12}>
                            <Form.Environments />
                        </Grid>
                        <Grid item md={6} sm={6} xs={12}>
                            <Form.BusinessApp />
                        </Grid>
                        {isNewLdapGroup && (
                            <Grid item md={6} sm={6} xs={12}>
                                <Form.ApplicationService />
                            </Grid>
                        )}
                        {isNewLdapGroup && (
                            <Grid item md={6} sm={6} xs={12}>
                                <Form.ProjectName />
                            </Grid>
                        )}
                        <Grid item md={6} sm={6} xs={12}>
                            <Form.AppOwnerSearch />
                        </Grid>
                    </Grid>
                </FormCard>
            </Grid>
            {(isNewLdapGroup ||
                isModifyLdapGroup ||
                isModifyAdGroup ||
                isModifyAdGroupMembershipRemoval ||
                isNewAdGroup ||
                isModifyAdGroupOwnerChange ||
                isDisableGroupRequest) && (
                <Grid item xs={12}>
                    <FormCard title="Resource" gap={0} margin={2}>
                        <Grid item container spacing={2} sx={{ mt: 1, mb: 1 }}>
                            {isNewLdapGroup && (
                                <>
                                    <Grid item md={6} sm={6} xs={12}>
                                        <Form.GroupOwner />
                                    </Grid>
                                    <Grid item md={6} sm={6} xs={12}>
                                        <Form.SelectMemberBtn />
                                    </Grid>
                                    <MembersListModal />
                                </>
                            )}
                            {isModifyLdapGroup && (
                                <>
                                    <Grid item md={6} sm={6} xs={12}>
                                        <Form.LDAPGroup />
                                    </Grid>
                                    <Grid item md={6} sm={6} xs={12}>
                                        <Form.SelectMemberBtn />
                                    </Grid>
                                    <MembersListModal />
                                </>
                            )}
                            {isModifyAdGroup && <ResourceSectionForModifyAdGroupMembership />}
                            {isModifyAdGroupMembershipRemoval && (
                                <>
                                    <Grid item md={6} sm={6} xs={12}>
                                        <ADGroupForRemoval />
                                    </Grid>
                                    {order?.adGroup && (
                                        <Grid item md={12} sm={12} xs={12}>
                                            <Form.ADGroupMembersRemoval />
                                        </Grid>
                                    )}
                                </>
                            )}
                            {isNewAdGroup && (
                                <>
                                    <ResourceSectionForNewAdGroupMembership />
                                </>
                            )}
                            {isModifyAdGroupOwnerChange && (
                                <>
                                    <ResourceSectionForAdGroupOwnerChange />
                                </>
                            )}
                            {isDisableGroupRequest && (
                                <>
                                    <ResourceSectionForDisable />
                                </>
                            )}
                        </Grid>
                    </FormCard>
                </Grid>
            )}
            {(isNewLdapGroup || isModifyLdapGroup) && (
                <>
                    <MemberslList />
                </>
            )}
            {isNewAdGroup && (
                <>
                    <NewAdGroupMembersList />
                </>
            )}
            {isModifyAdGroup && (
                <>
                    <MultipleMemberslList />
                </>
            )}
        </>
    );
};

export default MemberForm;
